<div class="color-picker-input">
    <mat-form-field>
        <mat-label>{{props.label | titlecase }} Color !!{{selectedColorHex()}}!!</mat-label>
        <input #colorInput matInput colorPicker="selectedColorHex" [style.background]="selectedColorHex()"
            title="{{props.label}}" (colorPickerSelect)="setSelectedColor($event)" />
    </mat-form-field>
    <!--selectedColorHex-->
    @if (props.displayPalette ) {
    @for ( thisVariation of selectedColorVariations;track thisVariation.hex) {
    <ul class="color-palette">
        <li class="color-palette-item" [style]="{'background-color': thisVariation.hex}">
            <span>{{thisVariation.weight}}</span>
            <span>{{thisVariation.hex}}</span>
        </li>
    </ul>
    }
    }
</div>